import BOTRecentlyViewedProducts from './BOTRecentlyViewedProducts'
import { compose, mapProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import withSetBazaarVoiceInlineRatings from 'components/common/hoc/withBazaarVoiceInlineRatings/withSetBazaarVoiceInlineRatings'

const withNormalizeRecentlyViewedItems = mapProps(({
  recentlyViewedTireItemList,
  recentlyViewedProducts,
  ...props
}) => ({
  ...props,
  records: (recentlyViewedTireItemList || recentlyViewedProducts || []).map(({ bvId }) => ({
    attributes: { bvId }
  })),
  recentlyViewedTireItemList: (recentlyViewedTireItemList || recentlyViewedProducts || []).map(item => ({
    ...item,
    skuImagePath: item.skuImagePath || item.productImageUrl,
    skuUrl: item.skuUrl || item.productUrl
  }))
}))

export default compose(
  withType({ type: 'BOTRecentlyViewedProducts' }),
  withNormalizeRecentlyViewedItems,
  withSetBazaarVoiceInlineRatings
)(BOTRecentlyViewedProducts)
